import { useEffect, useRef, useState } from "react";
import { Plus, Trash2, Video } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { toast } from "sonner";
import { api, formatApiErrorDetail, API } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [clientName, setClientName] = useState("");
  const [order, setOrder] = useState(0);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/testimonials").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    e.preventDefault();
    const file = fileRef.current?.files?.[0];
    if (!file) return toast.error("Selecione um vídeo");
    const fd = new FormData();
    fd.append("file", file);
    fd.append("client_name", clientName);
    fd.append("order", order);
    setUploading(true);
    try {
      await api.post("/admin/testimonials", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Depoimento enviado!");
      setClientName(""); setOrder(0); fileRef.current.value = "";
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setUploading(false); }
  };

  const toggleActive = async (t) => {
    await api.patch(`/admin/testimonials/${t.id}`, { active: !t.active });
    load();
  };

  const remove = async (id) => {
    await api.delete(`/admin/testimonials/${id}`);
    toast.success("Depoimento removido");
    load();
  };

  return (
    <div data-testid="admin-testimonials-page">
      <h1 className="text-2xl font-serif text-[#9B6179] mb-6">Depoimentos em Vídeo</h1>

      <div className="bg-white rounded-[2px] p-6 shadow-sm border border-[#9B6179]/5 mb-8">
        <p className="text-sm font-medium text-[#9B6179] mb-4">Novo depoimento</p>
        <form onSubmit={upload} className="grid sm:grid-cols-4 gap-3 items-end">
          <div className="sm:col-span-2"><Label>Nome da cliente</Label><Input required value={clientName} onChange={(e) => setClientName(e.target.value)} data-testid="testimonial-form-name" /></div>
          <div><Label>Ordem</Label><Input type="number" value={order} onChange={(e) => setOrder(e.target.value)} data-testid="testimonial-form-order" /></div>
          <div><Label>Vídeo (mp4)</Label><input ref={fileRef} type="file" accept="video/*" className="text-sm block mt-1" data-testid="testimonial-form-file" /></div>
          <Button disabled={uploading} type="submit" className="sm:col-span-4 bg-[#090708] text-[#E8C47A] rounded-[2px] hover:bg-[#6F3F55] transition-colors" data-testid="testimonial-form-submit">
            <Plus className="w-4 h-4 mr-1" /> {uploading ? "Enviando..." : "Enviar depoimento"}
          </Button>
        </form>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((t) => (
          <div key={t.id} className="bg-white rounded-[2px] p-4 shadow-sm border border-[#9B6179]/5" data-testid={`testimonial-card-${t.id}`}>
            <video src={`${API}/public/testimonials/${t.id}/video`} controls className="w-full h-40 object-cover rounded-[2px] bg-black mb-3" />
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-[#9B6179]">{t.client_name}</p>
                <p className="text-xs text-[#6F3F55]">Ordem: {t.order}</p>
              </div>
              <div className="flex items-center gap-3">
                <Switch checked={t.active} onCheckedChange={() => toggleActive(t)} data-testid={`testimonial-toggle-${t.id}`} />
                <button onClick={() => remove(t.id)} data-testid={`testimonial-delete-${t.id}`}><Trash2 className="w-4 h-4 text-[#6F3F55]" /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <p className="text-sm text-[#6F3F55] col-span-full flex items-center gap-2"><Video className="w-4 h-4" /> Nenhum depoimento em vídeo ainda.</p>
        )}
      </div>
    </div>
  );
}
